<template>
    <div>
        <div class="heading" style="display: flex;margin-bottom: 13px;">
            <div class="heading-left">
                <h4>Conditions</h4>
                <span class="info">As of {{ formattedMeasureTime }}</span>
            </div>
            <div class="heading-right">
                <div @click="scrollTo('.readings')" class="cursor-pointer mr-3 mr-sm-5">
                    <div class=" text-center">
                        <w-icon alt="Daily Water Temperature" height="30px" name="viewGraph"/>
                    </div>
                    <span class="info">View Graphs</span>
                </div>
                <div>
                    <div class="temp text-center">{{pool.waterTemp}}°F
                        <w-icon alt="Temperature" height="25px" name="temp"/>
                    </div>
                    <span class="info">Water Temperature</span>
                </div>
            </div>
        </div>
        <div class="body">
            <div class="line" v-for="meas in pool.measurements" :key="meas.type">
                <div class="name">
                    <span>{{meas.title}}</span>
                </div>
                <div class="bar">
                    <div class="d-flex">
                        <span class="bar-label bar-label-1" :style="{ width: '22%' }">
                            <span>{{ ranges(meas)['GREEN_MIN'] }}</span>
                        </span>
                        <span class="bar-label bar-label-2" :style="{ width: '56%' }">
                            <span>{{ ranges(meas)['GREEN_MAX'] }}</span>
                        </span>
                    </div>
                    <div class="dote" :style="{left: `${value(meas)}%`}"></div>
                    <div class="progress">
                        <div class="progress-bar" :style="{ width:'10%', backgroundColor: '#FF3B30'}"></div>
                        <div class="progress-bar" :style="{ width:'12%', backgroundColor: '#FAC504'}"></div>
                        <div class="progress-bar" :style="{ width:'56%', backgroundColor: '#23B8DC'}"></div>
                        <div class="progress-bar" :style="{ width:'12%', backgroundColor: '#FAC504'}"></div>
                        <div class="progress-bar" :style="{ width:'10%', backgroundColor: '#FF3B30'}"></div>
                    </div>
                    <!--<template v-if="meas.type === 'SKIMMER_FLOW'">-->
                    <!--<div class="progress" :style="{width: '78%'}">-->
                    <!--<div class="progress-bar" :style="{ width:'13%', backgroundColor: '#FF3B30'}"></div>-->
                    <!--<div class="progress-bar" :style="{ width:'15.5%', backgroundColor: '#FAC504'}"></div>-->
                    <!--<div class="progress-bar" :style="{ width:'71.5%', backgroundColor: '#23B8DC'}"></div>-->
                    <!--</div>-->
                    <!--</template>-->
                </div>
                <div class="action">
                    <w-icon name="chevron" alt="view" @click="selectedMeas = meas"
                            class="cursor-pointer" height="16px"/>
                    <!--<w-icon name="chevron" v-else alt="view" @click="showTimePicker = true"-->
                    <!--class="cursor-pointer" height="16px"/>-->
                </div>
            </div>
            <!--<div class="skimmer-time" v-if="skimmerTime">-->
            <!--<span v-if="senseOnly">Measure</span>-->
            <!--<span v-else>Dosing</span>-->
            <!--{{skimmerTime}}-->
            <!--</div>-->
            <!--<span class="skimmer-time cursor-pointer" @click="showTimePicker = true" v-else>-->
            <!--<i class="fa fa-warning"></i>-->
            <!--Set time-->
            <!--</span>-->
            <div class="line">
                <div class="name">
                    <span>Lab results</span>
                </div>
                <div class="bar lab-result-date">
                    <span>As of {{ formattedLabResultTime }}</span>
                </div>
                <router-link class="action" :to="{name: 'Lab', params: { id: pool.waterBodyId }}">
                    <w-icon alt="view" height="16px" name="chevron"/>
                </router-link>
            </div>
        </div>
        <w-timepicker :show-parent="showTimePicker"
                      :value="measTime"
                      :title="senseOnly ? 'Set Measurement Time' : 'Set Dosing Time'"
                      @input="saveMeasTime"
                      @closed="showTimePicker = false"
        ><span></span></w-timepicker>
        <w-bottom-modal :show="!!selectedMeas">
            <div class="text-center" v-if="selectedMeas">
                <div class="mb-5 modal-text">
                    {{selectedMeas.cfg.desc}}
                </div>
                <w-button :inverse="true" @click="selectedMeas = null" class="px-5">Close</w-button>
            </div>
        </w-bottom-modal>
    </div>
</template>

<script>
import { moment } from '../../plugins'
import { mapGetters, mapActions } from 'vuex'
import { lambda } from '../../amplify'
import scrollTo from 'animated-scroll-to'

export default {
    name: 'Conditions',
    data () {
        return {
            showTimePicker: false,
            measTime: '12:00 am',
            selectedMeas: null
        }
    },
    methods: {
        ...mapActions({
            getPools: 'pools/getPools'
        }),
        scrollTo (sel) {
            const el = document.querySelector(sel)
            const parent = document.querySelector('.dashboard')
            if (el) scrollTo(el, { element: parent, speed: 1000 })
        },
        value (meas) {
            const ranges = this.ranges(meas)
            const barRanges = [[10, 0], [12, 10], [56, 22], [12, 78], [10, 90]]
            const customRanges = [
                [ranges['RED_MIN'], ranges['YELLOW_MIN']],
                [ranges['YELLOW_MIN'], ranges['GREEN_MIN']],
                [ranges['GREEN_MIN'], ranges['GREEN_MAX']],
                [ranges['GREEN_MAX'], ranges['YELLOW_MAX']],
                [ranges['YELLOW_MAX'], ranges['RED_MAX']]
            ]
            const max = 100
            for (const index in customRanges) {
                const range = customRanges[index]
                if (meas.value >= range[0] && meas.value <= range[1]) {
                    return ((max * meas.value / range[1]) / max) * barRanges[index][0] + barRanges[index][1]
                }
            }
            return max
        },

        ranges (meas) {
            return meas.ranges || meas.cfg.intRanges || meas.cfg.floatRanges
        },

        to (path) {
            this.$router.push(path)
        },

        saveMeasTime (input) {
            const time = moment.utc(moment(input, 'hh:mm a')).format('HH:mm')
            lambda('updateWaterBody', {
                waterBody: {
                    waterBodyId: this.pool.waterBodyId,
                    measDoseHr: time.split(':')[0],
                    measDoseMin: time.split(':')[1]
                }
            }).then(response => {
                if (response.code === 'OK') this.getPools()
            })
        }
    },
    updated () {
        if (this.skimmerTime) {
            this.measTime = this.skimmerTime
        }
    },
    computed: {
        ...mapGetters({
            pool: 'pools/pool',
            labResult: 'pools/labResult',
            senseOnly: 'pools/senseOnly'
        }),
        formattedMeasureTime () {
            return moment(this.pool.latestMeasureTime).format('MM.DD.YY / h:mma')
        },
        formattedLabResultTime () {
            return moment(this.labResult ? this.labResult.latestMeasureTime : null).format('MMMM D, YYYY')
        },
        skimmerTime () {
            if (this.pool.waterBody.measDoseHr !== undefined && this.pool.waterBody.measDoseMin !== undefined) {
                const utc = `${this.pool.waterBody.measDoseHr}:${this.pool.waterBody.measDoseMin}`
                return moment.utc(utc, 'HH:mm').local().format('hh:mm a')
            } else return false
        }
    }
}
</script>

<style scoped lang="scss">

    .heading {
        display: flex;
        margin-bottom: 13px;

        .heading-left {
            flex-grow: 1;
        }

        .heading-right {
            display: flex;
            justify-content: space-between;
        }

        h4 {
            font-size: 40px;
            font-weight: 300;
            margin-bottom: 0;
        }

        .info {
            font-size: 12px;
            color: #7B8C9F;
        }

        .temp {
            font-size: 20px;
            font-weight: 300;
        }

    }

    .body {
        margin-left: 35px;

        .skimmer-time {
            i {
                color: #ff3b30;
                font-size: 20px;
            }

            font-size: 12px;
            width: 20%;
            position: relative;
            top: -53px;
            left: 78%;
            color: #96A7AF;
        }

        .dote {
            width: 3px;
            height: 14px;
            background-color: #7B8C9F;
            position: relative;
            top: 10px;
            border-radius: 1.5px;
        }

        .line {
            display: flex;
            margin-bottom: 40px;

            .name {
                width: 20%;
                line-height: 14px;

                span {
                    color: #1A3F65;
                    font-size: 20px;
                    font-weight: 600;
                }
            }

            .name, .action {
                display: flex;
                align-items: flex-end;
            }

            .bar {
                width: 76%;
                padding-right: 9px;

                .progress {
                    height: 7px;
                }

                .bar-label {
                    display: inline-block;
                    width: 30px;
                    color: #96A7AF;
                    font-size: 12px;
                    font-weight: 600;
                    text-align: right;
                }

                .bar-label > span {
                    display: inline-block;
                    transform: translateX(50%);
                }
            }

            .action {
                width: 5%;
                justify-content: flex-end;
            }

            .lab-result-date,
            .name {
                position: relative;
                color: #96A7AF;
                font-size: 14px;
                font-weight: 600;
                line-height: 16px;

                span {
                    position: absolute;
                    bottom: -3px;
                }
            }

        }
    }

    .modal-text {
        max-width: 500px;
        margin-left: auto;
        margin-right: auto;
    }

    @media (max-width: 1024px) {
        .body {
            margin-left: 0;

            .line .name span {
                font-size: 17px;
            }
        }
        .heading {
            h4 {
                font-size: 30px;
                font-weight: 600;
            }

            .info {
                font-size: 9px;
            }
        }
    }

    @media (max-width: 768px) {
        .body {
            margin-left: 0;
        }

        .body {

            .line {
                .name {
                    width: 29%;

                    span {
                        font-size: 14px;
                    }
                }

                .lab-result-date {
                    font-size: 12px;
                }

                .bar {
                    width: 67%;
                    padding-right: 9px;

                    .progress {
                        height: 4px;
                    }
                }

                .action {
                    width: 5%;
                    text-align: right;
                }
            }

            .skimmer-time {
                i {
                    font-size: 15px;
                }

                font-size: 10px;
            }
        }
    }
</style>
